import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const cartInfoShape = PropTypes.shape({
  orderKind: PropTypes.oneOf(['NEW', 'EDIT', 'SUBSTITUTION']),
  orderId: PropTypes.string,
  returnId: PropTypes.string,
  originalOrderId: PropTypes.string,
  orderCategoryId: PropTypes.string,
  orderCategoryName: PropTypes.string,
  orderCategoryDescription: PropTypes.string,
});

// Kind of order being built in the cart (from getCartInfo), with its references
const OrderContextInfo = ({ cartInfo }) => {
  const { t } = useTranslation();
  if (!cartInfo?.orderKind) return null;

  return (
    <div className="order-context-info">
      {cartInfo.orderKind === 'NEW' && (
        <span className="badge bg-secondary">{t('New Order')}</span>
      )}
      {cartInfo.orderKind === 'EDIT' && (
        <>
          <span className="badge bg-primary">{t('Editing order')}</span>{' '}
          <Link to={`/orders/${cartInfo.orderId}`}>{cartInfo.orderId}</Link>
        </>
      )}
      {cartInfo.orderKind === 'SUBSTITUTION' && (
        <>
          <span className="badge bg-warning text-dark">{t('Commercial Substitution Order')}</span>
          <br />
          {t('Return ID')}:{' '}
          <Link to={`/orders/${cartInfo.originalOrderId}/${cartInfo.returnId}`}>{cartInfo.returnId}</Link>
          {' · '}
          {t('Original Order ID')}:{' '}
          <Link to={`/orders/${cartInfo.originalOrderId}`}>{cartInfo.originalOrderId}</Link>
          {/* An edited substitute order also has its own order id */}
          {cartInfo.orderId && (
            <>
              {' · '}
              {t('Editing order')}: <Link to={`/orders/${cartInfo.orderId}`}>{cartInfo.orderId}</Link>
            </>
          )}
        </>
      )}
    </div>
  );
};

OrderContextInfo.propTypes = {
  cartInfo: cartInfoShape,
};

// Agreement category the cart is bound to: name (or description) with its id, description on hover
export const OrderCategoryInfo = ({ cartInfo }) => {
  const { t } = useTranslation();
  if (!cartInfo?.orderCategoryId) return null;

  const categoryLabel = cartInfo.orderCategoryName || cartInfo.orderCategoryDescription;
  return (
    <>
      {t('Category')}:{' '}
      <strong title={cartInfo.orderCategoryDescription || undefined}>
        {categoryLabel || cartInfo.orderCategoryId}
      </strong>
      {categoryLabel && ` (${cartInfo.orderCategoryId})`}
    </>
  );
};

OrderCategoryInfo.propTypes = {
  cartInfo: cartInfoShape,
};

export default OrderContextInfo;
